/* Minent — cartes produit : inclinaison 3D et lumière qui suit la souris (ordinateur seulement),
   bascule grille / liste des collections (mémorisée). */
(function () {
  'use strict';
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (fine && !calm) {
    var raf = 0;
    document.addEventListener('pointermove', function (e) {
      /* le lien du titre recouvre toute la carte : on part de la carte, puis on cible sa photo */
      var c = e.target.closest && e.target.closest('[data-mn-card]');
      var m = c && c.querySelector('[data-mn-tilt]');
      if (!m) return;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var r = m.getBoundingClientRect(), x = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)), y = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
        m.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
        m.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        m.style.setProperty('--ry', ((x - 0.5) * 10).toFixed(2) + 'deg');
        m.style.setProperty('--rx', ((0.5 - y) * 8).toFixed(2) + 'deg');
      });
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var c = e.target.closest && e.target.closest('[data-mn-card]');
      var m = c && c.querySelector('[data-mn-tilt]');
      if (m && !c.contains(e.relatedTarget)) { ['--mx', '--my', '--rx', '--ry'].forEach(function (k) { m.style.removeProperty(k); }); }
    }, { passive: true });
  }
  /* vue liste / grille des collections */
  var KEY = 'mn-view';
  function setView(v) {
    document.documentElement.setAttribute('data-mn-view', v);
    document.querySelectorAll('[data-mn-view-btn]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.mnViewBtn === v)); });
    try { localStorage.setItem(KEY, v); } catch (e) {}
  }
  var saved = 'grid'; try { saved = localStorage.getItem(KEY) || 'grid'; } catch (e) {}
  document.documentElement.setAttribute('data-mn-view', saved);
  document.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-mn-view-btn]'); if (b) setView(b.dataset.mnViewBtn); });
  function sync() { setView(document.documentElement.getAttribute('data-mn-view') || 'grid'); }
  if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
  /* les filtres de collection remplacent la grille : on resynchronise les boutons */
  function watch() {
    var pg = document.getElementById('ProductGridContainer');
    if (pg) new MutationObserver(sync).observe(pg, { childList: true });
  }
  if (document.readyState !== 'loading') watch(); else document.addEventListener('DOMContentLoaded', watch);
})();
